import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { ModelDecorationOptions } from '../../common/model/textModel.js';
import { Codicon, registerIcon } from '../../../base/common/codicons.js';
export var foldingExpandedIcon = registerIcon('folding-expanded', Codicon.chevronDown);
export var foldingCollapsedIcon = registerIcon('folding-collapsed', Codicon.chevronRight);
export var FoldingDecorationProvider = /*#__PURE__*/function () {
  function FoldingDecorationProvider(editor) {
    _classCallCheck(this, FoldingDecorationProvider);

    this.editor = editor;
    this.autoHideFoldingControls = true;
    this.showFoldingHighlights = true;
  }

  _createClass(FoldingDecorationProvider, [{
    key: "getDecorationOption",
    value: function getDecorationOption(isCollapsed, isHidden) {
      if (isHidden) {
        return FoldingDecorationProvider.HIDDEN_RANGE_DECORATION;
      }

      if (isCollapsed) {
        return this.showFoldingHighlights ? FoldingDecorationProvider.COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION : FoldingDecorationProvider.COLLAPSED_VISUAL_DECORATION;
      } else if (this.autoHideFoldingControls) {
        return FoldingDecorationProvider.EXPANDED_AUTO_HIDE_VISUAL_DECORATION;
      } else {
        return FoldingDecorationProvider.EXPANDED_VISUAL_DECORATION;
      }
    }
  }, {
    key: "deltaDecorations",
    value: function deltaDecorations(oldDecorations, newDecorations) {
      return this.editor.deltaDecorations(oldDecorations, newDecorations);
    }
  }, {
    key: "changeDecorations",
    value: function changeDecorations(callback) {
      return this.editor.changeDecorations(callback);
    }
  }]);

  return FoldingDecorationProvider;
}();
FoldingDecorationProvider.COLLAPSED_VISUAL_DECORATION = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  afterContentClassName: 'inline-folded',
  isWholeLine: true,
  firstLineDecorationClassName: foldingCollapsedIcon.classNames
});
FoldingDecorationProvider.COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  afterContentClassName: 'inline-folded',
  className: 'folded-background',
  isWholeLine: true,
  firstLineDecorationClassName: foldingCollapsedIcon.classNames
});
FoldingDecorationProvider.EXPANDED_AUTO_HIDE_VISUAL_DECORATION = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  isWholeLine: true,
  firstLineDecorationClassName: foldingExpandedIcon.classNames
});
FoldingDecorationProvider.EXPANDED_VISUAL_DECORATION = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */
  ,
  isWholeLine: true,
  firstLineDecorationClassName: 'alwaysShowFoldIcons ' + foldingExpandedIcon.classNames
});
FoldingDecorationProvider.HIDDEN_RANGE_DECORATION = ModelDecorationOptions.register({
  stickiness: 1
  /* NeverGrowsWhenTypingAtEdges */

});